import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BudgetMonthBase, IUserData } from '../../../common/entities';
import { setBudgetMonth } from '../actions/budgetMonth.actions';
import { getUserData } from '../actions/userData.actions';

export interface BudgetMonthState {
  monthBudgetDetails: BudgetMonthBase[];
  isLoading?: boolean;
  error?: string;
  lastAction?: string;
}

const initialState: BudgetMonthState = {
  monthBudgetDetails: [],
  isLoading: false,
  error: '',
  lastAction: ''
};

export const budgetMonthSlice = createSlice({
  name: 'budgetMonth',
  initialState: { ...initialState },
  reducers: {},
  extraReducers: {
    [getUserData.fulfilled.type]: (state, action: PayloadAction<IUserData>) => {
      state.isLoading = false;
      state.error = undefined;
      state.monthBudgetDetails = action.payload.monthBudgetDetails ?? [];
    },
    [setBudgetMonth.fulfilled.type]: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.error = '';
      state.lastAction = action.type;
    },
    [setBudgetMonth.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = action.type;
    },
    [setBudgetMonth.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    }
  }
});

export default budgetMonthSlice.reducer;
